import React from 'react';

const OrderCountdownTimer = ({ initialRemainingTime, onComplete, containerStyle, textClassName }) => {
  const [remainingTime, setRemainingTime] = React.useState(initialRemainingTime);

  React.useEffect(() => {
    if (remainingTime <= 0) {
      if (onComplete) onComplete();
      return;
    }
    const timer = setInterval(() => {
      setRemainingTime(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          if (onComplete) onComplete();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [remainingTime, onComplete]);

  const hours = Math.floor(remainingTime / 3600);
  const minutes = Math.floor((remainingTime % 3600) / 60);
  const seconds = remainingTime % 60;

  let timeFormatted = '';
  if (hours > 0) {
    timeFormatted = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  } else {
    timeFormatted = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  return (
    <div style={containerStyle}>
      <span className={textClassName} style={{ color: '#E62529', lineHeight: '1' }}>{timeFormatted}</span>
    </div>
  );
};

export default OrderCountdownTimer;
